// extracted by mini-css-extract-plugin
module.exports = {"screenreaderonly":"R4PCWm","clearfix":"_3ZgRwG","confirm":"_11HHWx"};